import React, { useState, useEffect } from "react";
import InputWrapper from "../../general/InputWrapper";
import classes from "./NumericInput.module.css";

const NumericInput = ({
  title,
  desc_text,
  extra_text,
  help_text,
  inputObject,
  fieldName,
  inputs,
  updateInput,
  errors,
  currencySymbol = false,
  percentSymbol = false,
  min = 0,
  max = 500000,
  msgs
}) => {
  const [displayValue, setDisplayValue] = useState("");

  useEffect(() => {
    const inputFieldValue = inputs[inputObject][fieldName] || "";
    setFormattedDisplayValue(inputFieldValue);
  }, [inputs, fieldName, currencySymbol]);

  const setFormattedDisplayValue = (value) => {
    const numericValue = value.replace(/,/g, "");
    const formattedValue = formatValueWithCommas(numericValue);

    setDisplayValue(
      formattedValue
        ? currencySymbol
          ? `£${formattedValue}`
          : percentSymbol
          ? `${formattedValue}%`
          : formattedValue
        : ""
    );
  };

  const formatValueWithCommas = (value) => {
    const parts = value.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  };

  const handleChange = (e) => {
    let inputValue = e.target.value.replace(/[^0-9.]/g, "");

    if (inputValue.split(".").length > 2) {
      inputValue = `${inputValue.split(".")[0]}.${inputValue
        .split(".")
        .slice(1)
        .join("")}`;
    }

    if (inputValue !== "" && !inputValue.startsWith("0.")) {
      inputValue = inputValue.replace(/^0+(?=\d)/, "");
    }

    const numericValue = parseFloat(inputValue);
    if (!isNaN(numericValue)) {
      if (numericValue < min) inputValue = String(min);
      if (numericValue > max) inputValue = String(max);
    }

    setFormattedDisplayValue(inputValue);

    updateInput(inputObject, fieldName, inputValue.replace(/,/g, ""));
  };

  return (
    <InputWrapper
      title={title}
      desc_text={desc_text}
      extra_text={extra_text}
      help_text={help_text}
      error_text={errors[fieldName]}
      msg_text={msgs[fieldName]}
    >
      <section className={classes.input_container}>
        <input
          type="text"
          name={fieldName}
          value={displayValue}
          onChange={handleChange}
          placeholder="Enter amount"
          required
        />
      </section>
    </InputWrapper>
  );
};

export default NumericInput;
